import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { ConfirmationDialogComponent } from '../../Components/dialogs/common/confirmation-dialog/confirmation-dialog.component';
import { CONSTANTS } from '../../Constants/Constants';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  constructor(private readonly dialog: MatDialog) {}

  confirm(type: string, title: string, message: string, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH, showIcon: boolean = false): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width,
      disableClose: true,
      data: { type, title, message, showIcon }
    });

    return dialogRef.afterClosed().pipe(
      map(result => result === true)
    );
  }

  confirmWarning(message: string, title: string = CONSTANTS.WARNING_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH, showIcon: boolean = false): Observable<boolean> {
    return this.confirm(CONSTANTS.TYPE_WARNING, title, message, width, showIcon);
  }

  confirmInfo(message: string, title: string = CONSTANTS.INFO_TITLE, width: string = CONSTANTS.DEFAULT_DIALOG_WIDTH, showIcon: boolean = false): Observable<boolean> {
    return this.confirm(CONSTANTS.TYPE_INFO, title, message, width, showIcon);
  }
}
